import { render } from "./PageSwitch.vue?vue&type=template&id=3d0c37ee&scoped=true"
import script from "./PageSwitch.vue?vue&type=script&lang=js"
export * from "./PageSwitch.vue?vue&type=script&lang=js"

import "./PageSwitch.vue?vue&type=style&index=0&id=3d0c37ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0c37ee"]])

export default __exports__